import { RacLogo } from '@whitelabel/Components/RacLogo';

export const headerLogoMap = {
  rac: RacLogo,
};
